import { execOnLoad, getCssVariable } from '@general/helpers';
import { throttle } from 'lodash';
import Cookies from 'js-cookie';
import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import './announcement-bar.scss';
import 'swiper/scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initAnnouncementBar = (context) => {
  const sectionContainer = context.classList.contains('.shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;
  const innerContainer = sectionContainer.querySelector(
    '.announcement-bar__container',
  );
  const backgroundContainer = sectionContainer.querySelector(
    '.announcement-bar__background',
  );
  if (!innerContainer || !backgroundContainer) return;

  const toggleAnnouncement = (close = true) => {
    var startHeight = '0px';
    var endHeight = `${innerContainer.clientHeight}px`;

    if (close) {
      startHeight = `${innerContainer.clientHeight}px`;
      endHeight = '0px';
      Cookies.set('announcement-closed', 'true', { expires: 7 });
    }
    const animation = sectionContainer.animate(
      {
        height: [startHeight, endHeight],
      },
      {
        duration: 300,
        easing: 'ease-out',
      },
    );
    animation.onfinish = () => {
      backgroundContainer.classList.toggle('hidden');
      resizeCallback();
    };
  };

  const animationSpeed = getCssVariable(innerContainer, '--animation-speed');

  const closeBtn = sectionContainer.querySelector('.announcement-bar__close');
  if (closeBtn) {
    closeBtn.addEventListener('click', toggleAnnouncement);
    const announcementClosed = Cookies.get('announcement-closed');
    if (announcementClosed !== 'true') toggleAnnouncement(false);
  }

  const resizeCallback = throttle(
    () =>
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${sectionContainer.clientHeight}px`,
      ),
    500,
  );
  resizeCallback();
  window.addEventListener('resize', resizeCallback);

  if (
    innerContainer.classList.contains('announcement-bar__container--carousel')
  ) {
    const prevArrow = sectionContainer.querySelector(
      '.announcement-bar__arrow--left',
    );
    const nextArrow = sectionContainer.querySelector(
      '.announcement-bar__arrow--right',
    );

    const options = {
      modules: [Autoplay, ...(prevArrow && nextArrow ? [Navigation] : [])],
      loop: innerContainer.querySelectorAll('.swiper-slide').length >= 2,
      direction: innerContainer.dataset?.scrollDirection ?? 'horizontal',
      autoHeight: innerContainer.dataset?.scrollDirection === 'vertical',
      autoplay: {
        enabled: true,
        delay: animationSpeed * 3000,
      },
      ...(prevArrow && nextArrow
        ? {
            navigation: {
              prevEl: prevArrow,
              nextEl: nextArrow,
            },
          }
        : {}),
    };

    new Swiper(innerContainer, options);
  } else if (
    innerContainer.classList.contains('announcement-bar__container--marquee')
  ) {
    const messagesWrapper = innerContainer.querySelector(
      '.announcement-bar__messages-wrapper',
    );
    if (!messagesWrapper) return;
    const messagesAccumulator = messagesWrapper.parentElement;
    const duplicationCount =
      Math.ceil(innerContainer.clientWidth / messagesWrapper.clientWidth) - 1;
    messagesAccumulator.appendChild(messagesWrapper.cloneNode(true));

    for (var i = 0; i < duplicationCount; i++) {
      messagesAccumulator.appendChild(messagesWrapper.cloneNode(true));
      messagesAccumulator.appendChild(messagesWrapper.cloneNode(true));
    }

    innerContainer.style.setProperty(
      '--animation-duration',
      `${Math.ceil(messagesAccumulator.clientWidth / 300) * animationSpeed}s`,
    );
    messagesAccumulator.style.animationPlayState = `running`;
  }
};

execOnLoad(window.dAgency.initAnnouncementBar, '.announcement-bar__section');
